export default __webpack_public_path__ + "static/tad_suv_1-a0c11e74234224adc9d12b889ca52684.jpeg";